
<style>
    .pieChart{
        width: 100%;
        height: 350px;
        display: inline-block;
        background-color: #1e094e;
        box-shadow: 0 2px 12px 0 rgba(30,9,78, 1);
    }
    .ratio_class{
		height: 450px !important;
	}
	@media screen and (min-width:2200px){
		.ratio_class{
			height: 600px !important;
		}
	}
</style>

<template>
    <div>
        <div :class="{ratio_class : useData.id == 'pieChart1'|| useData.id == 'pieChart3'}"  class="pieChart Chart" :id="useData.id"></div>
    </div>
</template>
<script>
    export default {
        name: 'pieChart',
        props: ['dataBol','useData','widthPxMess'],
        data(){
            return {
                myChart:false,
                colorStyle : ['#325bf1','#fc5469','#3dc1cd','#ffd814','#ff7214']
            }
        }, 
        watch: {
            'dataBol': {
                handler (n) {
                    let _this = this;
                    if(n){
                        if(!_this.myChart){
                            let myChart = _this.$echarts.init(document.getElementById(_this.useData.id));
                            _this.myChart = myChart;
                        }
                        _this.drawChart();  
                    }
                }
            }
        },
        methods: {
            drawChart(){
                let _this = this;
                let pieMess = _this.useData.data;
                let legendMess = _this.useData.legendArr;
                let newLegendArr = [];
                legendMess.forEach((ele,index) => {
                    newLegendArr.push({
                        name : ele,
                        textStyle : {
                            color: _this.colorStyle[index]
                        }
                    });
                })
                let pieNum = 0;
                pieMess.forEach((ele)=>{
                    pieNum += ele.value
                });
                _this.myChart.setOption({
                    title:{
                        text:_this.useData.title,
                        textStyle:{
                            color: '#ffffff',
                            fontWeight: 'bold',
                            fontSize:_this.widthPxMess.titleSize
                        },
                        x:'center',
                        y:'20',
                    },
                    animation: true,
                    tooltip: {
                        trigger: 'item',
                        formatter: '{a} <br/>{b} : {c} ({d}%)'
                    },
                    legend: {
                        icon: "circle", 
                        itemWidth: 10,
                        itemHeight: 10,
                        orient: 'vertical',
                        right: 20,
                        top: 'middle',
                        selectedMode: false,
                        data: newLegendArr,
                        formatter: function (name) {
                            let target;
                            for (let i = 0; i < pieMess.length; i++) {
                                if (pieMess[i].name === name) {
                                    target = pieMess[i].value
                                }
                            }
                            let arr = ["{a|" + name + "}" , "{b|" + ((target/pieNum.toFixed(2)*100).toFixed(0) + '%') + "}"]
                            return arr.join(" ")
                        },
                        textStyle:{
                            lineHeight: 24,
                            rich: {
                                a: {
                                    fontSize: _this.widthPxMess.legendSize,
                                    color: "#fff",
                                    padding: [0, 0, 0, 0],
                                    width:_this.useData.aw,
                                },
                                b: {
                                    fontSize: _this.widthPxMess.legendSize,
                                    padding: [0, 0, 0, 0],
                                    width:_this.useData.bw,
                                }
                            },
                        },
                    },
                    series: [
                        {
                            name: _this.useData.title,
                            type: 'pie',
                            radius: _this.useData.radius,
                            center: ['35%', '50%'],
                            data: pieMess,
                            label:{
                                show:false
                            },
                        }
                    ],
                    color:_this.colorStyle,
                })
            }
        }
    }
</script>